import BSHtmlBaseBTStrategy from './BSHtmlBaseBTStrategy'

export default function BSHtmlNonBillableBTStrategy() {}

BSHtmlNonBillableBTStrategy.prototype = new BSHtmlBaseBTStrategy()

BSHtmlNonBillableBTStrategy.prototype.addFirstHeaderRowCells = function(row, levelsNumber) {
    this.addCreatedCell(row, this.createNonBillableCell(levelsNumber))
}

BSHtmlNonBillableBTStrategy.prototype.addColumnValueCells = function(row) {
    this.addTimeColumnValueCells(row)
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlNonBillableBTStrategy.js